<template>
    <div class="page form-submitted" data-aos="fade-up">

        <!-- Receipt Content (PDF Target) -->
        <div class="submitted-card" ref="receiptRef">
            <img src="@/assets/check-mark.png" alt="Success" class="checkmark" />
            <h1>Thank You!</h1>
            <p>Your application has been successfully submitted. We appreciate your interest and will be in touch soon.
            </p>
            <p>You’ll also receive an email with a link to set up your applicant portal account—please check your spam folder if you don’t see it.</p>
            <p><strong>Confirmation ID:</strong> {{ confirmationId }}</p>
            <p><strong>Name:</strong> {{ application?.firstName }} {{ application?.lastName }}</p>
            <p><strong>Email:</strong> {{ application?.email }}</p>
            <p><strong>Company Applying For:</strong> {{ application?.companySelected }}</p>
            <p><strong>Position Applying For:</strong> {{ application?.positionapplying }}</p>
            <p><strong>Submitted At:</strong> {{ formattedDate }}</p>
            <div v-if="application?.applicantSignatureDataUrl">
                <p><strong>Signature:</strong></p>
                <img :src="application.applicantSignatureDataUrl" alt="Signature" class="signature-image" />
            </div>
        </div>

        <!-- Buttons (not included in PDF) -->
        <div class="submitted-actions">
            <button @click="downloadReceipt" class="btn-secondary">Download Receipt</button>
            <router-link to="/" class="btn-primary">Return to Home</router-link>
        </div>

    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import html2pdf from 'html2pdf.js'
import 'swiper/css';
import 'swiper/css/autoplay'; // (keep this for autoplay styles)

import AOS from 'aos'
import 'aos/dist/aos.css'
const route = useRoute()


const confirmationId = route.query.id || null
const application = ref(null)
const receiptRef = ref(null)
const formattedDate = ref('')
onMounted(async () => {
    // Initialize AOS animations
    AOS.init({
        duration: 1000,
        once: true,
    })

    // Receipt saved by the application form for this submission
    // (applications aren't publicly readable, so it isn't fetched from Firestore)
    if (confirmationId) {
        try {
            const saved = sessionStorage.getItem(`receipt:${confirmationId}`)
            if (saved) {
                application.value = JSON.parse(saved)
                formattedDate.value = new Date(application.value.submittedAt).toLocaleString()
            }
        } catch (error) {
            console.error('Error loading application receipt:', error)
        }
    }
})

const downloadReceipt = () => {
    const element = receiptRef.value
    const options = {
        margin: 0.5,
        filename: `application-receipt-${confirmationId}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    }
    html2pdf().from(element).set(options).save()
}
</script>
<style scoped>
.page.form-submitted {
    padding: 2rem;
    display: flex;
    flex-direction: column;
    /* 🔁 stack items vertically */
    align-items: center;
    min-height: 80vh;
    background-color: #f9f9f9;
}

.submitted-card {
    background: white;
    padding: 2.5rem;
    border-radius: 12px;
    text-align: center;
    max-width: 500px;
    width: 100%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.checkmark {
    width: 80px;
    height: 80px;
    margin-bottom: 1rem;
}

.submitted-card h1 {
    color: #2ecc71;
    font-size: 2rem;
    margin-bottom: 0.5rem;
}

.submitted-card p {
    font-size: 1rem;
    color: #555;
    margin-bottom: 2rem;
}

.btn-primary {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    background-color: #3498db;
    color: white;
    border-radius: 6px;
    text-decoration: none;
    font-weight: bold;
    transition: background 0.3s ease;
}

.btn-primary:hover {
    background-color: #2980b9;
}

@media print {

    .btn-primary,
    .btn-secondary,
    .checkmark {
        display: none;
    }
}

.submitted-actions {
    margin-top: 1.5rem;
    display: flex;
    justify-content: center;
    gap: 1rem;
    flex-wrap: wrap;
}

.btn-secondary {
    padding: 0.75rem 1.5rem;
    background-color: white;
    color: #333;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.btn-secondary:hover {
    background-color: #f0f0f0;
    border-color: #999;
}
.signature-image {
  margin-top: 1rem;
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  background: #fff;
}

</style>